import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/Services.scss';
import { cmsAPI, getImageUrl } from '../utils/api';

function Services() {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || 'http://localhost:8000';



  useEffect(() => {
    cmsAPI.getServices()
      .then(res => {
        if (res.data.success) {
          const parsedServices = res.data.data.map(s => ({
            ...s,
            features: s.features ? s.features.split(',').map(f => f.trim()).filter(Boolean) : [],
            tech: s.tech ? s.tech.split(',').map(t => t.trim()).filter(Boolean) : []
          }));
          setServices(parsedServices);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching services:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero" style={{ backgroundImage: "linear-gradient(135deg, rgba(10, 37, 64, 0.85), rgba(0, 82, 106, 0.85)), url('/images/hero-bg.jpg')" }}>
        <h1>Our Services</h1>
        <p>Comprehensive technology solutions for your business</p>
      </section>

      {/* Services Detail Sections */}
      <div className="services-details">
        {loading ? (
          <p style={{ textAlign: 'center', padding: '50px 0' }}>Loading services...</p>
        ) : services.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '50px 0' }}>No services available right now.</p>
        ) : (
          services.map((service, index) => (
            <section key={service.id} className={`service-section ${index % 2 !== 0 ? 'reverse' : ''}`}>
              <div className="service-container">
                <div className="service-image">
                  <img 
                    src={getImageUrl(service.image)} 
                    alt={service.title} 
                  />
                </div>
                <div className="service-content">
                  <span className="service-tag">Service {String(index + 1).padStart(2, '0')}</span>
                  <h2>{service.title}</h2>
                  <p className="service-description">{service.description}</p>
                  
                  {service.features && service.features.length > 0 && (
                    <div className="service-features">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="feature-item">
                          <span className="check">✓</span>
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {service.tech && service.tech.length > 0 && (
                    <div className="tech-badges">
                      {service.tech.map((tech, idx) => (
                        <span key={idx} className="tech-badge">{tech}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </section>
          ))
        )}
      </div>

      {/* CTA Section */}
      <section className="services-cta" style={{ backgroundImage: "url('/images/cta-bg.jpg')" }}>
        <div className="cta-overlay"></div>
        <div className="cta-content">
          <h2>Ready to Transform?</h2>
          <p>Let us help you build the technology solutions that will propel your business forward. Get in touch with our team today and start your digital transformation journey.</p>
          <div className="cta-buttons">
            <button className="btn-primary" onClick={() => navigate('/contact')}>Start Your Project →</button>
            <button className="btn-secondary" onClick={() => navigate('/contact')}>Get a Quote</button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
